import api from "../../../lib/axios";
import type { BaseResponse } from "../../../lib/api-contract";
import type { SyncPointItem, SyncPointsPage, SyncPointsStatus } from "../types/syncPoints.types";

interface RawItem {
  user_id: string;
  user_name: string;
  user_email: string;
  available_points: number;
  has_wallet_transaction: boolean;
  wallet_transaction_points: number;
}
interface RawPage {
  list?: RawItem[];
  paging?: { count?: number; total?: number };
}

const unwrap = <T>(value: BaseResponse<T> | T): T =>
  typeof value === "object" && value !== null && "data" in value
    ? (((value as BaseResponse<T>).data ?? {}) as T)
    : value;

export async function getSyncPoints(
  params: { index: number; size: number; name: string; status: SyncPointsStatus },
  signal?: AbortSignal,
): Promise<SyncPointsPage> {
  const response = await api.get<BaseResponse<RawPage>>("/v1/portal/sync-points", {
    params: { ...params, ...(params.name ? { name: params.name } : {}) },
    signal,
  });
  const payload = unwrap(response.data);
  return {
    items: (payload.list ?? []).map((item): SyncPointItem => ({
      userId: item.user_id,
      userName: item.user_name,
      userEmail: item.user_email,
      availablePoints: item.available_points,
      hasWalletTransaction: item.has_wallet_transaction,
      walletTransactionPoints: item.wallet_transaction_points,
    })),
    totalCount: payload.paging?.count ?? payload.paging?.total ?? 0,
  };
}
